import { render, staticRenderFns } from "./ProdutoRoute.vue?vue&type=template&id=1517e790"
import script from "./ProdutoRoute.vue?vue&type=script&lang=js"
export * from "./ProdutoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports